import { GlobalActions, GlobalActionTypes } from './types';
import { Dispatch } from 'react';

export const setLoading = () => async (dispatch: Dispatch<GlobalActions>) => {
  dispatch({ type: GlobalActionTypes.LOADING });
};

export const setSuccess = () => async (dispatch: Dispatch<GlobalActions>) => {
  dispatch({ type: GlobalActionTypes.SUCCESS_LOAD });
};

export const setMapReady = () => (dispatch: Dispatch<GlobalActions>) => {
  dispatch({ type: GlobalActionTypes.MAP_READY });
};
